import { useMemo } from 'react';

import type { AlertColor } from '@frontierag/frontier-ui-library';
import { Alert, Box } from '@frontierag/frontier-ui-library';
import { APP_PRODUCT_TYPE, ORDER_STATUS, ORDER_STATUS_SYNC } from 'appConstants';
import type { IOrderSubHeader } from 'components/OrderSubHeader/types';
import { isDateTimeBefore } from 'utils';

export default function OrderSubHeader({
  orderStatus,
  messages,
  createdAt,
  productType,
}: IOrderSubHeader) {
  const orderSubHeaderData = useMemo(() => {
    const productTypeConfig = {
      [APP_PRODUCT_TYPE.ENVIRONMENTAL_CROPS]: {
        createdLimitHours: ORDER_STATUS_SYNC.ENV_CROPS_PROCESSING_HOURS,
        messageValues: {
          processingTime: ORDER_STATUS_SYNC.ENV_CROPS_PROCESSING_HOURS,
        },
      },
    };

    return {
      createdLimitHours: ORDER_STATUS_SYNC.CREATED_LIMIT_HOURS,
      messageValues: {},
      ...(productType ? productTypeConfig[productType] : {}),
    };
  }, [productType]);

  const subHeaderData = useMemo(() => {
    const statusMessage = messages[orderStatus];
    const message = statusMessage?.(orderSubHeaderData.messageValues);

    if (orderStatus === ORDER_STATUS.ERROR) {
      return { severity: 'error', message };
    }

    if (orderStatus === ORDER_STATUS.DRAFT) {
      return { severity: 'warning', message };
    }

    if (
      orderStatus === ORDER_STATUS.OPEN &&
      isDateTimeBefore(createdAt, orderSubHeaderData.createdLimitHours, 'hours')
    ) {
      return { severity: 'warning', message };
    }
  }, [createdAt, messages, orderStatus, orderSubHeaderData]);

  const message = subHeaderData?.message;

  if (!message) return null;

  const severity = subHeaderData?.severity as AlertColor;

  return (
    <Box pb={2}>
      <Alert severity={severity}>{message}</Alert>
    </Box>
  );
}
